<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <p>
        &copy; {{new Date().getFullYear()}} Cloudprinter.com B.v.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'Foot',

  computed: {
  }
}
</script>

<style lang="sass">
  .footer
    position: fixed
    bottom: 0
    width: 100%
    padding: 0.5rem
</style>
